import { request } from "./request";

export const getAllBids = (params) => {
	return request({
		method: 'post',
		url: '/dashboard/bid',
		params
	})
}
